// eslint-disable-next-line import/prefer-default-export
export function steps(state = ['/'], action) {
  switch (action.type) {
    // todo improve logic of this reducer. move calculations to action
    // eslint-disable-next-line no-case-declarations
    case 'PUSH_STEP':
      const allowedSteps = state.concat();
      allowedSteps[action.stepNumber] = action.stepName;
      return allowedSteps;
    case 'RESET_STEPS':
      return ['/'];
    default:
      return state;
  }
}
